export const MULTI = 'MULTI';
export const SINGLE = 'SINGLE';